
import { DevicesActivity } from '../DevicesActivity';
import { VenuesOrg } from '../VenuesOrg';

export class DevicesActivityPa extends DevicesActivity {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/DevicesActivityPa.js